import { createCategoryHandler } from "../category-dispatcher";
import { validateTools } from "./validate-tools";
import { validationInputTools } from "./validation-input-tools";

/**
 * Category handler for validation operations.
 * Consolidates validation-input-tools and validate-tools handlers.
 * All operations are synchronous.
 */
export const handleValidationCategory = createCategoryHandler({
  list: validationInputTools.sync!.ui_common_list_validations,
  add: validationInputTools.sync!.ui_common_add_validation,
  update: validationInputTools.sync!.ui_common_update_validation,
  remove: validationInputTools.sync!.ui_common_remove_validation,
  validate_screen: validateTools.sync!.ui_validate_screen
});
